export const EMAIL_ALREADY_SENT_MESSAGE =
  'An invite has already been sent to this address';

export const EMAIL_REQUIRED = 'Email Is Required';

export const TEAM_REQUIRED = 'Team Is Required';

export const INCORRECT_EMAIL_FORMAT =
  'Entered value does not match email format';
